import {
  DELETE_SCENARIO_REQUEST,
  DELETE_SCENARIO_SUCCESS,
  DELETE_SCENARIO_ERROR,
  GET_SCHEDULE_ACTIVITIES,
  GET_CHANCE_OF_SUCCESS_REQUEST,
  GET_CHANCE_OF_SUCCESS_SUCCESS,
  GET_CHANCE_OF_SUCCESS_ERROR,
  GET_SCENARIOS_REQUEST,
  GET_SCENARIOS_SUCCESS,
  GET_SCENARIOS_SUCCESS_AND_SET_ACTIVE_SCENARIO,
  GET_SCENARIOS_ERROR,
  GET_SCENARIO_REQUEST,
  GET_SCENARIO_SUCCESS,
  GET_SCENARIO_ERROR,
  GENERATE_SCHEDULE_REQUEST,
  GENERATE_SCHEDULE_SUCCESS,
  GENERATE_SCHEDULE_ERROR,
  UPDATE_SCENARIO_REQUEST,
  UPDATE_SCENARIO_SUCCESS,
  UPDATE_SCENARIO_ERROR,
  CLEAR_CURRENT_SCENARIO,
  GET_SCENARIO_METRIC_REQUEST,
  GET_SCENARIO_METRIC_SUCCESS,
  GET_SCENARIO_METRIC_ERROR,
  SET_CURRENT_SCENARIO,
  UPDATE_SCENARIOS_ERROR,
  UPDATE_SCENARIOS_REQUEST,
  UPDATE_SCENARIOS_SUCCESS,
  COPY_SCENARIO_REQUEST,
  COPY_SCENARIO_SUCCESS,
  COPY_SCENARIO_ERROR,
  CREATE_SCENARIO_REQUEST,
  CREATE_SCENARIO_SUCCESS,
  CREATE_SCENARIO_ERROR,
  UPDATE_CURRENT_SCENARIO_REQUEST,
  UPDATE_CURRENT_SCENARIO_SUCCESS,
  UPDATE_CURRENT_SCENARIO_ERROR,
  UPDATE_SCENARIO_STATE,
  MARK_FEVER_CHART_SUCCESS,
  GET_ALL_APPROVED_SCENARIOS_REQUEST,
  GET_ALL_APPROVED_SCENARIOS_SUCCESS,
  GET_ALL_APPROVED_SCENARIOS_ERROR,
  CONVERT_TO_AUTOMATIC_REQUEST,
  CONVERT_TO_AUTOMATIC_SUCCESS,
  CONVERT_TO_AUTOMATIC_ERROR,
  GET_SWAP_SCENARIOS_REQUEST,
  GET_SWAP_SCENARIOS_SUCCESS,
  GET_SWAP_SCENARIOS_ERROR,
  GET_EVM_REQUEST,
  GET_EVM_SUCCESS,
  GET_EVM_ERROR,
  UPDATE_DOR_WITH_CONFORM_PROGRESS_SUCCESS,
  UPDATE_DATE_OF_REVIEW_SUCCESS,
  GET_SUB_CODES_OF_PROJECT,
  GET_PORTFOLIO_SCENARIOS_REQUEST,
  GET_PORTFOLIO_SCENARIOS_SUCCESS,
  GET_PORTFOLIO_SCENARIOS_ERROR,
  DELETE_PORTFOLIO_SCENARIO_ERROR,
  DELETE_PORTFOLIO_SCENARIO_SUCCESS,
  DELETE_PORTFOLIO_SCENARIO_REQUEST,
  ADD_PORTFOLIO_SCENARIO,
  UPDATE_PORTFOLIO_SCENARIO_REQUEST,
  UPDATE_PORTFOLIO_SCENARIO_SUCCESS,
  UPDATE_PORTFOLIO_SCENARIO_ERROR,
  APPROVE_PORTFOLIO_SCENARIO,
  SET_PORTFOLIO_SCENARIO_AS_SIMULATED,
  REJECT_PORTFOLIO_SCENARIO,
  GET_PORTFOLIO_SCENARIO_NAME,
  SELECT_PORTFOLIO_SCENARIO,
  SELECT_PORTFOLIO_BASELINE,
  RESET_ASSUMPTIONS,
  SET_ACTIVE_SCENARIO,
  CLEAR_PROJECTS_SCENARIO,
} from "../types";
import { AUTOMATIC_PC, SYNC, UNSYNC } from "../../global/constants";
import produce from "immer";
import { updateItemInArray } from "../../utils/FilterUtils/FilterUtils";
import { sanitizeUrlId } from "../../pages/GenerativeSchedulingExperimentalPage/urlParams";
import { pickDefaultScenario } from "./scenarioVersion";

const initialState = {
  items: [],
  item: {},
  // Set when the URL points to a scenario id that the most recent
  // GET_SCENARIOS_SUCCESS_AND_SET_ACTIVE_SCENARIO could not match. Route
  // guards observe this and redirect instead of letting components
  // render against an empty `item` (which causes white-page crashes
  // when consumers read state.scenario.item.X.Y on deep paths).
  itemNotFound: false,
  isUpdating: false,
  isCopying: false,
  scheduleActivities: [],
  approvedScenarios: [],
  portfolioScenarios: [],
  selectedPortfolioScenarioId: null,
  selectedPortfolioBaselineId: null,
  swapScenarios: [],
  subCodes: [],
  isFetching: false,
  error: "",
};

const initialState2 = {
  scenarioMetric: {},
  currentPortfolioScenarioName: "",
  evmData: {},
  chanceOfSuccess: 100, // TODO
  isMetricsFetching: false,
  isChanceFetching: false,
  isEVMFetching: false,
  error: "",
};

// eslint-disable-next-line
export function scenarioReducer(state = initialState, { type, payload }) {
  switch (type) {
    case CREATE_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isFetching = true;
        draftState.items = [];
      });
    case CREATE_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.items = [...draftState.items, payload];
        draftState.item = payload;
      });
    case CREATE_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.error = payload;
      });
    case COPY_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isCopying = true;
        draftState.error = "";
      });
    case COPY_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isCopying = false;
        if (!draftState.items.some((s) => s.id === payload.id)) {
          draftState.items = [...draftState.items, payload];
        }
      });
    case COPY_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isCopying = false;
        draftState.error = payload;
      });
    case UPDATE_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
        draftState.error = "";
      });
    case UPDATE_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.items = updateItemInArray(draftState.items, payload);
      });
    case UPDATE_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case UPDATE_SCENARIOS_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
        draftState.error = "";
      });
    case UPDATE_SCENARIOS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.items = [...draftState.items].map(
          (item) => payload.find((p) => p.id === item.id) || item
        );
      });
    case UPDATE_SCENARIOS_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case GENERATE_SCHEDULE_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: "",
      };
    case GENERATE_SCHEDULE_SUCCESS:
      return {
        ...state,
        isFetching: false,
      };
    case GENERATE_SCHEDULE_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    case CLEAR_PROJECTS_SCENARIO:
      return produce(state, draftState => {
        if (Array.isArray(draftState.items) && draftState.items.length > 0)
          draftState.items = [];
      });
    case GET_SCENARIOS_REQUEST:
      return produce(state, (draftState) => {
        draftState.isFetching = true;
        draftState.items = [];
        draftState.item = {};
        draftState.itemNotFound = false;
        draftState.error = "";
      });
    case GET_SCENARIOS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.items = payload;
      });
    case GET_SCENARIOS_SUCCESS_AND_SET_ACTIVE_SCENARIO:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.items = payload.items;
        draftState.itemNotFound = false;

        const items = Array.isArray(payload.items) ? payload.items : [];
        // sanitizeUrlId collapses the literal "undefined" / "null" that
        // callers interpolate into the route when a project has no
        // currentScenarioId yet — those are truthy strings that slip past
        // a plain `!id` check.
        const scenarioId = sanitizeUrlId(payload.currentScenarioId);
        const parsedId = Number(scenarioId);

        if (scenarioId !== null && Number.isFinite(parsedId)) {
          const found = items.find((s) => s.id === parsedId);
          if (found) {
            draftState.item = found;
          } else {
            // The URL points at a scenario that's no longer in the list
            // (common after a delete-then-navigate race). Flag it so the
            // route can redirect; do NOT install an empty {} on `item`
            // — downstream consumers read deep paths like
            // state.scenario.item.structure.X and crash with TypeError.
            draftState.itemNotFound = true;
          }
          return;
        }

        // No usable id in the URL. A project that owns scenarios always
        // has one selected by definition, so resolve the default here
        // rather than leaving `item` empty: ScheduleViewPage then rewrites
        // the URL to the canonical one and the Gantt mounts against a real
        // scenario instead of parsing "undefined" into an Invalid Date.
        draftState.item = pickDefaultScenario(items) || {};
      });
    case GET_SCENARIOS_ERROR:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.error = payload;
      });
    case GET_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isFetching = true;
        draftState.item = {};
        draftState.itemNotFound = false;
        draftState.error = "";
      });
    case GET_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.item = payload;
        draftState.itemNotFound = false;
      });
    case GET_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.error = payload;
      });
    case DELETE_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
      });
    case DELETE_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.items = [...state.items].filter(
          (item) => item.id !== payload
        );
        // If the just-deleted scenario is the one currently being
        // viewed, drop it from `item` too. Otherwise a fast Copy click
        // (or any nav that triggers re-fetch) lands us on the
        // SCENARIOS_SUCCESS_AND_SET_ACTIVE path with a now-missing id,
        // and consumers that read state.scenario.item.X.Y crash.
        if (state.item && state.item.id === payload) {
          draftState.item = {};
        }
      });
    case DELETE_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case GET_SCHEDULE_ACTIVITIES:
      return {
        ...state,
        scheduleActivities: payload,
      };
    case UPDATE_CURRENT_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
        draftState.error = "";
      });
    case UPDATE_CURRENT_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.item = payload;
        draftState.items = updateItemInArray(draftState.items, payload);
      });
    case UPDATE_DATE_OF_REVIEW_SUCCESS:
      // NOTE: The PATCH /date-of-review endpoint now returns ConformProgressDTO and
      // dispatches UPDATE_DOR_WITH_CONFORM_PROGRESS_SUCCESS instead. This case is
      // kept for backward compatibility with any direct callers that still pass a
      // plain dateOfReview string.
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.item = { ...draftState.item, dateOfReview: payload };
        const scenarioItem = { id: draftState.item.id, dateOfReview: payload };
        draftState.items = updateItemInArray(draftState.items, scenarioItem);
      });
    case UPDATE_DOR_WITH_CONFORM_PROGRESS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.item.dateOfReview = payload.dateOfReview;
        const scenarioItem = {
          id: payload.scenarioId,
          dateOfReview: payload.dateOfReview,
        };
        draftState.items = updateItemInArray(draftState.items, scenarioItem);
      });
    case UPDATE_CURRENT_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case CLEAR_CURRENT_SCENARIO:
      return {
        ...state,
        item: {},
        itemNotFound: false,
      };
    case SET_CURRENT_SCENARIO:
      return {
        ...state,
        item: payload,
        itemNotFound: false,
      };
    case UPDATE_SCENARIO_STATE:
      return produce(state, (draftState) => {
        // The scenarios-view route loads a thin scenario item without
        // `structure`; a throw here aborts the caller's dispatch chain
        // (e.g. the post-import Gantt refetch in the add-scope flow).
        if (draftState.item?.structure) {
          draftState.item.structure.state = payload ? SYNC : UNSYNC;
        }
      });
    case MARK_FEVER_CHART_SUCCESS:
      return {
        ...state,
        item: payload,
      };

    case GET_ALL_APPROVED_SCENARIOS_REQUEST:
      return {
        ...state,
        isFetching: true,
        approvedScenarios: payload,
      };
    case GET_ALL_APPROVED_SCENARIOS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        approvedScenarios: payload,
      };

    case GET_ALL_APPROVED_SCENARIOS_ERROR:
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    case CONVERT_TO_AUTOMATIC_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
      });
    case CONVERT_TO_AUTOMATIC_SUCCESS:
      return produce(state, (draftState) => {
        draftState.item.automatic = true;
        draftState.item.fullyManual = false;
        draftState.isUpdating = false;
      });
    case CONVERT_TO_AUTOMATIC_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case GET_SWAP_SCENARIOS_REQUEST:
      return produce(state, (draftState) => {
        draftState.error = "";
      });
    case GET_SWAP_SCENARIOS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.swapScenarios = payload || [];
      });
    case GET_SWAP_SCENARIOS_ERROR:
      return produce(state, (draftState) => {
        draftState.error = payload;
      });
    case GET_SUB_CODES_OF_PROJECT:
      return produce(state, (draftState) => {
        draftState.subCodes = payload;
      });
    case ADD_PORTFOLIO_SCENARIO:
      return produce(state, (draftState) => {
        const newPortfolioScenarios = draftState.portfolioScenarios.slice();
        newPortfolioScenarios.push(payload);
        draftState.portfolioScenarios = newPortfolioScenarios;
      });
    case GET_PORTFOLIO_SCENARIOS_REQUEST:
      return produce(state, (draftState) => {
        draftState.isFetching = true;
      });
    case GET_PORTFOLIO_SCENARIOS_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.portfolioScenarios = payload;
      });
    case GET_PORTFOLIO_SCENARIOS_ERROR:
      return produce(state, (draftState) => {
        draftState.isFetching = false;
        draftState.error = payload;
      });
    case DELETE_PORTFOLIO_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
      });
    case DELETE_PORTFOLIO_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.portfolioScenarios = draftState.portfolioScenarios.filter(
          (scenario) => scenario.id !== payload
        );
      });
    case DELETE_PORTFOLIO_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case UPDATE_PORTFOLIO_SCENARIO_REQUEST:
      return produce(state, (draftState) => {
        draftState.isUpdating = true;
      });
    case UPDATE_PORTFOLIO_SCENARIO_SUCCESS:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.portfolioScenarios = draftState.portfolioScenarios.map(
          (scenario) => {
            if (scenario.id === payload.id) {
              scenario.name = payload.name;
              scenario.description = payload.description;
            }
            return scenario;
          }
        );
      });
    case UPDATE_PORTFOLIO_SCENARIO_ERROR:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.error = payload;
      });
    case APPROVE_PORTFOLIO_SCENARIO:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.portfolioScenarios = draftState.portfolioScenarios.map(
          (scenario) => {
            if (scenario.id === payload) scenario.approved = true;
            else scenario.approved = false;

            return scenario;
          }
        );
      });
    case REJECT_PORTFOLIO_SCENARIO:
      return produce(state, (draftState) => {
        draftState.isUpdating = false;
        draftState.portfolioScenarios = draftState.portfolioScenarios.map(
          (scenario) => {
            if (scenario.id === payload) scenario.approved = false;

            return scenario;
          }
        );
      });
    case SET_PORTFOLIO_SCENARIO_AS_SIMULATED:
      return produce(state, (draftState) => {
        draftState.portfolioScenarios = draftState.portfolioScenarios.map(
          (scenario) => {
            if (scenario.id === payload) scenario.simulated = true;
            return scenario;
          }
        );
      });
    case SELECT_PORTFOLIO_SCENARIO:
      return produce(state, (draftState) => {
        draftState.selectedPortfolioScenarioId = payload;
      });
    case SELECT_PORTFOLIO_BASELINE:
      return produce(state, (draftState) => {
        draftState.selectedPortfolioBaselineId = payload;
      });
    case RESET_ASSUMPTIONS:
      return produce(state, (draftState) => {
        draftState.item = {
          ...draftState.item,
          resourceBottleneck: {},
          resourceCapacityType: {},
          resourceSimulationInterval: {},
          resourceVariance: {},
        };
      });
    case SET_ACTIVE_SCENARIO:
      return produce(state, (draftState) => {
        draftState.item =
          draftState.items.find((item) => item.id === payload) || {};
      });
    default:
      return state;
  }
}

export function scenarioMetricsReducer(
  state = initialState2,
  { type, payload }
) {
  switch (type) {
    case GET_SCENARIO_METRIC_REQUEST:
      return {
        ...state,
        isMetricsFetching: true,
        error: "",
      };
    case GET_SCENARIO_METRIC_SUCCESS:
      return {
        ...state,
        scenarioMetric: payload,
        isMetricsFetching: false,
      };
    case GET_SCENARIO_METRIC_ERROR:
      return {
        ...state,
        isMetricsFetching: false,
        error: payload,
      };
    case GET_CHANCE_OF_SUCCESS_REQUEST:
      return {
        ...state,
        isChanceFetching: true,
      };
    case GET_CHANCE_OF_SUCCESS_SUCCESS:
      return {
        ...state,
        isChanceFetching: false,
        chanceOfSuccess: payload,
      };
    case GET_CHANCE_OF_SUCCESS_ERROR:
      return {
        ...state,
        isChanceFetching: false,
        error: payload,
      };
    case GET_EVM_REQUEST:
      return {
        ...state,
        isEVMFetching: true,
      };
    case GET_EVM_SUCCESS:
      return {
        ...state,
        isEVMFetching: false,
        evmData: payload,
      };
    case GET_EVM_ERROR:
      return {
        ...state,
        isEVMFetching: false,
        error: payload,
      };
    case GET_PORTFOLIO_SCENARIO_NAME:
      return {
        ...state,
        currentPortfolioScenarioName: payload,
      };
    default:
      return state;
  }
}
